import React, { PropsWithChildren } from 'react'

import { Footer, Header, ScrollToTop } from 'Components/Blocks'
import { Column } from 'Components/UI'

import { HEADER_HEIGHT_PX } from 'Constants/Navigation'
import { Z_INDICES } from 'Constants/ZIndices'

import { useResponsiveLayout } from 'Hooks'

import { Container, type ContainerProps } from './styles'

type Props = PropsWithChildren &
  ContainerProps & {
    hideMobileHeader?: boolean
  }

function PublicLayout({ children, secondary, hideMobileHeader }: Props) {
  const { isDesktop } = useResponsiveLayout()

  return (
    <Container secondary={secondary}>
      <ScrollToTop />

      <Column grow relative>
        {(!hideMobileHeader || isDesktop) && <Header />}

        <Column
          alignCenter
          grow
          pt={isDesktop ? HEADER_HEIGHT_PX.DESKTOP : 0}
          zIndex={Z_INDICES.BASE_CONTENT}
        >
          {children}
        </Column>
      </Column>

      <Footer />
    </Container>
  )
}

export default PublicLayout
